import React from 'React';
import axios from 'axios';

class ProductHighlights extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      highlights: [],
    };
  }

  _isMounted = false;

  componentDidMount() {
    this._isMounted = true;
    this.getHighlights(this.props.product);
  }

  getHighlights(product) {
    axios({
      url: '/api/2024-04/graphql.json',
      method: 'post',
      headers: {
        'X-Shopify-Storefront-Access-Token': 'a405dd74f8328bdcd981ff3210ccac7c',
        'Content-Type': 'application/json',
      },
      data: {
        query: `
        query {
          productByHandle(handle: "${product}") {
              metafields(identifiers: [{namespace: "highlights", key: "highlight"}]) {
                type
                namespace
                key
                value
              }
            }
        }
        `,
      },
    })
      .then((response) => {
        if (this._isMounted) {
          this.setState({
            highlights: JSON.parse(
              response.data.data.productByHandle.metafields[0].value
            ),
          });
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    return (
      <ul className="results-nourishment__highlights">
        {this.state.highlights.map((item, index) => (
          <li key={index}>{item}</li>
        ))}
      </ul>
    );
  }
}

export default ProductHighlights;
